import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Reserved for API diagnostics. Console logging of failed requests was removed —
 * expected statuses (e.g. 403 on `/admin/me`) were too noisy in the console.
 */
export const kcc20ApiDiagnosticsInterceptor: HttpInterceptorFn = (req, next) =>
  next(req);
